/**
 * Copyright © Born, Inc. All rights reserved.
 * See COPYING.txt for license details.
 */

define('Born_MapClub/js/model/quote-mixin',[
    'mage/utils/wrapper',
    'Born_MapClub/js/model/payment/mapclub'
], function (wrapper, mapclubAccount) {
    'use strict';

    return function (quote) {
        quote.setTotals = wrapper.wrapSuper(quote.setTotals, function (data) {
            this._super(data);
            mapclubAccount.usedPoints(data['extension_attributes']['mapclub_points']);
        });

        return quote;
    };
});
